<template>
  <div>
    <div class="fixed-header">
      <div class="heading">CORPORATE LIST</div>
    </div>

    <div class="row">
      <div class="column medium-12">
        <div class="card"><list-filter :isMobile="isMobile"></list-filter></div>
      </div>
    </div>


    <div class="row">
      <div class="column medium-12">
        <div class="card">
          <list-table :isMobile="isMobile"></list-table>
          <!-- <table class="main-table">
            <thead>
              <th>Logo</th>
              <th>Username</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Status</th>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td class="email-logo"><img :src="user.logo"></td>
                <td><a :href="'/#/corporate/' + user.id" target="_blank">{{ user.username }}</a></td>
                <td>{{ user.name }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.mobile }}</td>
                <td class="status">
                  <div class="switch">
                    <div :class="{'slider':true, 'active':user.active, 'disabled':statusLoading.indexOf(user.id) > -1}"
                      @click="toggleStatus(user.id, user.active)"></div>
                    <span class="label" v-if="user.active">ACTIVE</span>
                    <span class="label" v-else>DEACTIVATED</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import listFilter from './ListFilter'
import listTable from './ListTable'

export default {
  name: 'corporate',
  components: { listFilter, listTable },
  data () {
    return {
      isMobile: false
    }
  },
  computed: {
    users () { return this.$store.state.corporate.users.list },
    loading () { return this.$store.state.corporate.users.loading }
  },
  methods: {
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  mounted () {
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
.fixed-header{
  width: 100%;
  margin-bottom: 30px;
}
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.card{ margin-bottom: 10px; }

@media only screen and (max-width: 430px) {
  .fixed-header{
    width: 100%;
    margin-bottom: 0;
  }

  .card {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/index.vue